export default __webpack_public_path__ + "static/media/td.56281165.png";